// https://github.com/nuxt/nuxt/issues/14766
const assets = import.meta.glob('~/assets/images/**/*', {
  eager: true,
  import: 'default',
})
export function useAsset<T>(_path: MaybeRef<string>) {
  const path = computed(() => unref(_path))
  return computed(() => assets[`/assets${path.value}`] as T)
}
